
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/touren",
      function () {
        return require("private-next-pages/touren.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/touren"])
      });
    }
  